import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectEdit from './pages/ProjectEdit';
import NavBar from './components/NavBar';
import { AuthProvider, useAuth } from './context/AuthContext';
import styled from 'styled-components';
import Admin from './pages/Admin';
import './App.css'; // Import the CSS file

const MainContent = styled.div`
  padding-top: 64px; /* Adjust based on the height of your NavBar */
  background-color: white; /* Keep the container color as is */
  margin: 0 auto; /* Center the container */
  max-width: 1200px; /* Set a max width for the container */
  padding: 20px; /* Add some padding */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
  border-radius: 8px; /* Add rounded corners */
`;

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="scrollbar-reserved">
          <ConditionalNavBar />
          <MainContent>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
              <Route path="/projects/:projectId" element={<ProtectedRoute><ProjectEdit /></ProtectedRoute>} />
              <Route path="/project-edit/:projectId" element={<ProtectedRoute><ProjectEdit /></ProtectedRoute>} />
-             <Route path="/project-edit/:projectId" element={<ProtectedRoute><ProjectEdit /></ProtectedRoute>} />
-             <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/" element={<Navigate to="/dashboard" />} />
            </Routes>
          </MainContent>
        </div>
      </Router>
    </AuthProvider>
  );
}

function ConditionalNavBar() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Show NavBar only if the user is authenticated and not on the login page
  if (isAuthenticated && location.pathname !== '/login') {
    return <NavBar />;
  }
  return null;
}

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
}

export default App;